module.exports = __webpack_public_path__ + "static/media/coach-overlay.a3b4f6a9.png";